export default "__VITE_ASSET__cXShZQjf__"